import React, { useState } from 'react';
import PlanningBalanceCard from '../../soplanning/cards/PlanningBalanceCard';
import PlanningHistoryCard from '../../soplanning/cards/PlanningHistoryCard';
import { SALES_ORDER_EXISTING_PLANS } from '../../../config/api';

function SalesOrderTable({ orders }) {
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [planningData, setPlanningData] = useState({});

  const handleShowPlanning = async (order) => {
    if (expandedOrderId === order.id) {
      setExpandedOrderId(null); // toggle off
      return;
    }

    try {
      const res = await fetch(SALES_ORDER_EXISTING_PLANS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sales_order_id: order.id })
      });

      const result = await res.json();

      if (Array.isArray(result)) {
        setPlanningData((prev) => ({ ...prev, [order.id]: result }));
        setExpandedOrderId(order.id);
      } else {
        alert('No planning data found.');
      }
    } catch (err) {
      console.error('Fetch planning failed:', err);
      alert('Failed to load planning');
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-striped table-sm align-middle">
        <thead className="table-light">
          <tr>
            <th>SO No</th>
            <th>Customer</th>
            <th>Customer PO No</th>
            <th>PO Date</th>
            <th>Remark</th>
            <th>Qty</th>
            <th>Price</th>
            <th>GST%</th>
            <th>Attachments</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => {
            const item = order.items?.[0] || {};
            const qty = parseFloat(item.qty || 0);
            const price = parseFloat(item.price || 0);
            const gst = parseFloat(item.gst || 0);

            return (
              <React.Fragment key={order.id}>
                <tr>
                  <td>{order.order_no || `SO-${order.id}`}</td>
                  <td>{order.customer_name}</td>
                  <td>{order.customer_po_no}</td>
                  <td>{order.po_date}</td>
                  <td>{order.remark || '—'}</td>
                  <td>{qty.toFixed(3)}</td>
                  <td>₹{price.toFixed(2)}</td>
                  <td>{gst.toFixed(2)}%</td>
                  <td>
                    {order.attachments?.length > 0 ? (
                      <span className="text-success fw-bold">Yes ({order.attachments.length})</span>
                    ) : (
                      <span className="text-muted">No</span>
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleShowPlanning(order)}
                    >
                      SO Status view
                    </button>
                   
                  </td>
                </tr>

                {/* Expanded Planning Details */}
                {expandedOrderId === order.id && (
                  <tr>
                    <td colSpan="10">
                      <div className="p-2 bg-light rounded">
                        <h6 className="text-primary mb-2">Planning Overview</h6>
                        {planningData[order.id]?.length > 0 && (
                          <>
                            <PlanningBalanceCard
                              materialList={order.items}
                              existingPlans={planningData[order.id]}
                            />
                            <PlanningHistoryCard
                              plans={planningData[order.id]}
                              onEdit={(plan) => {
                                const el = document.getElementById(`plan-row-${plan.planning_id}`);
                                if (el) el.scrollIntoView({ behavior: 'smooth' });
                              }}
                            />
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default SalesOrderTable;
